/**
 * Receive an object to convert in URLSearchParams
 * @param type => (false: 'UPC') - (true: 'ISRC')
 * @param value => Value to search
 * @returns {URLSearchParams}
 */
export default (type, value) => {
  return new URLSearchParams( {
    [type ? 'isrc' : 'upc']: value
  })
}
